<section class="container about-section" id="about-us">
  <!-- about content section -->
  <div class="about-section__content">
    <!-- about title -->
    <h4 class="content-title">
      {{ 'global.about' | translate }}
      <span class="content-title__company-name">{{
        aboutData()?.title | translateData
      }}</span>
    </h4>
    <!-- about description -->
    <p class="content-description">
      {{ aboutData()?.about_description | translateData }}
    </p>
    <!-- contact us button -->
    <div class="about-section__options">
      <!-- business card -->
      @if (aboutData()?.card) {
        <a [href]="baseUrl + aboutData()?.card?.url" target="_blank">
          <pwj-button
            variant="primary"
            icon="chevron-right"
            size="large"
            [rotateIconInRtl]="true"
            [iconReversePosition]="true"
            >{{ 'global.businessCard' | translate }}</pwj-button
          >
        </a>
      }

      <!-- catalog -->
      @if (aboutData()?.catalogs && aboutData().catalogs.length > 0) {
        <a [href]="baseUrl + aboutData()?.catalogs?.[0]?.url" target="_blank">
          <pwj-button
            variant="primary"
            icon="chevron-right"
            size="large"
            [rotateIconInRtl]="true"
            [iconReversePosition]="true"
            >{{ 'global.catalog' | translate }}</pwj-button
          >
        </a>
      }
    </div>
  </div>

  <!-- about gallery section -->

  @if (aboutData()?.photo_urls && aboutData().photo_urls.length > 0) {
    <div class="about-section__gallery">
      <!-- media gallery -->
      <pwj-gallery
        [mediaData]="aboutData()?.photo_urls || []"
        [mediaListCount]="2"
        [isColumnListMode]="true"
        previewWidth="674"
        previewHeight="384"
        previewWidthClass="!w-674"
        previewHeightClass="!h-384"
        listImgWidth="200"
        listImgWidthClass="!w-200"
        listImgHeight="112"
        listImgHeightClass="!h-112"
        [previewAlt]="(aboutData()?.title | translateData) || ''"></pwj-gallery>
    </div>
  }
</section>
